module.exports = __webpack_public_path__ + "static/drider-9bc461ffc3273a51bfd5b7990ffaefe4.jpg";